// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import './SectionContent.scss'
import { useContextMenu } from './SectionContainer'


interface SectionContentProps {
  children: React.ReactNode
  contextPanel?: React.FC<any> | null
  contextPanelProps?: any
  nogutter?: boolean
}


const SectionContent: React.FC<SectionContentProps> = ({
  children,
  nogutter,
  ...props
}) => {
  const ctx = useContextMenu()
  const classes: string[] = []
  const ContextPanel: React.FC<any> | null = props.contextPanel || null
  let activePanel: React.ReactNode | null = null
  if (ContextPanel !== null) {
    activePanel = (<ContextPanel {...(props.contextPanelProps || {})}/>)
  }

  if (!!nogutter) { classes.push("expand") }
  return (
    <main className={classes.join(' ')}>
      {children}
      {activePanel || ctx.render()}
    </main>
  )
}


export default SectionContent